import React from 'react';
import ReactDOM from 'react-dom/client';

// Chunk 404 after a new deployment → force reload to pick up the new hub-app.html
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});
import '../shared/license-storage.js';
import '../shared/license.js';
import '../shared/limits.js';
import App from './App';
import './design-system.css';
import './index.css';
import './shared/ui/mobile/mobile.css';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js').catch(() => {});
}

// Mobile gestures (swipe-to-go-back)
import { initMobileGestures } from '@shared/mobileGestures';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize gestures after mount
setTimeout(() => {
  try { initMobileGestures(); } catch (_e) { /* no-op */ }
}, 200);
